import http from './api'

const route = 'app/menu/'

export default {
  showPermissions: (id, tokenContrato) => {
    return http.post(route + 'showPermissions', {
      id: id,
      tokenContrato: tokenContrato,
    })
  },

  showUsuarios: (tokenContrato) => {
    return http.post(route + 'showUsuarios', {
      tokenContrato: tokenContrato,
    })
  },

  salvarPermissao: (pagina, id, username, selectPermissao, tokenContrato) => {
    return http.post(route + 'salvarPermissao', {
      pagina: pagina,
      id: id,
      username: username,
      selectPermissao: selectPermissao,
      tokenContrato: tokenContrato,
    })
  },

  showPermissionsUsuario: (username, tokenContrato) => {
    return http.post(route + 'showPermissionsUsuario', {
      username: username,
      tokenContrato: tokenContrato,
    })
  },

  verificarPermissaoPaginaUsuario: (username, url, tokenContrato) => {
    return http.post(route + 'verificarPermissaoPaginaUsuario', {
      username: username,
      url: url,
      tokenContrato: tokenContrato,
    })
  },

  showUser: (userId, username, tokenContrato) => {
    return http.post(route + 'showUser', {
      userId: userId,
      username: username,
      tokenContrato: tokenContrato,
    })
  },

  showPaginas: (tokenContrato) => {
    return http.post(route + 'showPaginas', {
      tokenContrato: tokenContrato,
    })
  },

  showPaginasMaster: (tokenContrato) => {
    return http.post(route + 'showPaginasMaster', {
      tokenContrato: tokenContrato,
    })
  },

  showPermissaoPagina: (username, pagina, tokenContrato, codigo) => {
    return http.post(route + 'showPermissaoPagina', {
      username: username,
      pagina: pagina,
      tokenContrato: tokenContrato,
      codigo: codigo,
    })
  },

  excluirPermissao: (username, pagina, tokenContrato) => {
    return http.post(route + 'excluirPermissao', {
      username: username,
      pagina: pagina,
      tokenContrato: tokenContrato,
    })
  },

  showEmpresas: (tokenContrato, username) => {
    return http.post(route + 'showEmpresas', {
      tokenContrato: tokenContrato,
      username: username,
    })
  },

  showVersion: (tokenContrato, nomeVersao) => {
    return http.post(route + 'showVersion', {
      tokenContrato: tokenContrato,
      nomeVersao: nomeVersao,
    })
  },

  showInformacoes: (tokenContrato, pagina, informacoesSelect) => {
    return http.post(route + 'showInformacoes', {
      tokenContrato: tokenContrato,
      pagina: pagina,
      informacoesSelect: informacoesSelect,
    })
  },

  atualizarDescricao: (item, tokenContrato) => {
    return http.post(route + 'atualizarDescricao', {
      item: item,
      tokenContrato: tokenContrato,
    })
  },

  showOrientacaoPagina: (tokenContrato, codigoId) => {
    return http.post(route + 'showOrientacaoPagina', {
      codigo: codigoId,
      tokenContrato: tokenContrato,
    })
  },

  showPaginasContrato: (pagina, moduloSelect, paginaSelect) => {
    return http.post(route + 'showPaginasContrato', {
      pagina: pagina,
      moduloSelect: moduloSelect,
      paginaSelect: paginaSelect,
    })
  },

  showContratosVinculados: (paginaId, pageContratoPagina, tokenContrato, contratoSelect) => {
    return http.post(route + 'showContratosVinculados', {
      paginaId: paginaId,
      pageContratoPagina: pageContratoPagina,
      tokenContrato: tokenContrato,
      contratoSelect: contratoSelect,
    })
  },

  atualizarPermissao: (listaContrato, paginaId) => {
    return http.post(route + 'atualizarPermissao', {
      listaContrato: listaContrato,
      paginaId: paginaId,
    })
  },

  removerPermissao: (contrato, paginaId) => {
    return http.post(route + 'removerPermissao', {
      contrato: contrato,
      paginaId: paginaId,
    })
  },

  showDadosVendedores: (tokenContrato, userId) => {
    return http.post(route + 'showDadosVendedores', {
      tokenContrato: tokenContrato,
      userId: userId,
    })
  },

  showSalvarDadosRelacao: (tokenContrato, userId, username, vendedores) => {
    return http.post(route + 'showSalvarDadosRelacao', {
      tokenContrato: tokenContrato,
      userId: userId,
      username: username,
      vendedores: vendedores,
    })
  },

  removerVendedorRelacao: (tokencontrato, userId, username, vendedor) => {
    return http.post(route + 'removerVendedorRelacao', {
      tokenContrato: tokencontrato,
      userId: userId,
      username: username,
      vendedor: vendedor,
    })
  },

  showOrientacaoIndicador: (username, tokencontrato, codigo) => {
    return http.post(route + 'showOrientacaoIndicador', {
      tokenContrato: tokencontrato,
      username: username,
      codigo: codigo,
    })
  },
}
